import {useQuery, UseQueryResult} from '@tanstack/react-query';
import {benefactorsApi} from '../api';
import {OrderDetailModel} from '../model';

type OrderByIdState = {
  getOrder: UseQueryResult<OrderDetailModel, Error>;
  refetchOrder: () => void;
};

export const useOrderById = (orderId: string): OrderByIdState => {
  const getOrder = useQuery<OrderDetailModel, Error>({
    queryKey: ['order', orderId],
    queryFn: () => benefactorsApi.getOrderById(orderId),
    enabled: !!orderId,
    staleTime: 60 * 1000,
  });

  const refetchOrder = () => {
    getOrder.refetch();
  };

  return {
    getOrder,
    refetchOrder,
  };
};
